import React, { createContext, useMemo } from 'react';
import { useReducer } from '@olxeu-a2b/delivery-utils/src/extras';

const TemplateContext = createContext();
TemplateContext.displayName = 'TemplateContext';

const SET_TITLE = '@template/SET_TITLE';
const SET_SUBTITLE = '@template/SET_SUBTITLE';
const SET_BACK_BEHAVIOUR = '@template/SET_BACK_BEHAVIOUR';
const SET_NO_MOBILE_HEADER = '@template/SET_NO_MOBILE_HEADER';
const SET_INFO_BLOCK = '@template/SET_INFO_BLOCK';
const RESTORE_DEFAULT = '@template/RESTORE_DEFAULT';

const defaultInfo = {
  title: '',
  subTitle: '',
  noMobileHeader: false,
  forceDesktop: false,
  onBack: null,
};

const templateReducer = (state, { type, payload }) => {
  switch (type) {
  case SET_TITLE:
    return { ...state, title: payload };

  case SET_SUBTITLE:
    return { ...state, subTitle: payload };

  case SET_BACK_BEHAVIOUR:
    return { ...state, onBack: payload };

  case SET_NO_MOBILE_HEADER:
    return { ...state, noMobileHeader: payload };

  case SET_INFO_BLOCK:
    return { ...state, ...payload };

  case RESTORE_DEFAULT:
    return { ...defaultInfo };

  default:
    return state;
  }
};

export const TemplateProvider = ({ children }) => {
  const [templateInfo, dispatch] = useReducer(templateReducer, defaultInfo);

  const templateConfig = useMemo(
    () => ({
      templateInfo,
      setTitle: title => dispatch({ type: SET_TITLE, payload: title }),
      setSubTitle: subTitle => dispatch({ type: SET_SUBTITLE, payload: subTitle }),
      setOnBack: onBack => dispatch({ type: SET_BACK_BEHAVIOUR, payload: onBack }),
      setNoMobileHeader: noHeader => dispatch({ type: SET_NO_MOBILE_HEADER, payload: noHeader }),
      setInfoBlock: info => dispatch({ type: SET_INFO_BLOCK, payload: info }),
      restoreDefault: () => dispatch({ type: RESTORE_DEFAULT }),
    }),
    [templateInfo],
  );

  return <TemplateContext.Provider value={templateConfig}>{children}</TemplateContext.Provider>;
};
export default TemplateContext;
